import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('issuer_source', '/issuer_sources')
const reducer = generator.generate()

export default reducer
